class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop hover: open menu on mouseenter, close on mouseleave with delay
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isDesktop) {
      let closeTimeout;

      this.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        this.mainDetailsToggle.setAttribute('open', '');
      });

      this.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          this.mainDetailsToggle.removeAttribute('open');
        }, 150);
      });
    }

    // Allow parent links to navigate instead of toggling dropdown
    const parentLink = this.querySelector('.mega-menu__parent-link');
    if (
      parentLink &&
      parentLink.href &&
      parentLink.href !== '#' &&
      !parentLink.href.endsWith('#')
    ) {
      parentLink.addEventListener('click', (e) => {
        e.stopPropagation();
        window.location.href = parentLink.href;
      });
    }

    // Make summary only toggle on caret click, not entire area
    const summary = this.querySelector('summary');
    if (summary && parentLink) {
      summary.addEventListener('click', (e) => {
        if (e.target.closest('.mega-menu__parent-link')) {
          e.preventDefault();
        }
      });
    }
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    const isDesktop = window.innerWidth >= 990;

    if (
      isDesktop &&
      document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === ''
    ) {
      const headerBottom = Math.floor(this.header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${headerBottom}px`
      );
    } else if (!isDesktop) {
      document.documentElement.style.setProperty('--header-bottom-position-desktop', '0px');
    }
  }
}

// ✅ THIS was missing in your snippet
customElements.define('header-menu', HeaderMenu);
